import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter, Selection } from 'devextreme-react/data-grid';
import Loader from '../../Utils/Loader/NewLoader2025'
import type { ColumnCellTemplateData } from 'devextreme/ui/data_grid';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import DateBox from 'devextreme-react/date-box';
import { Button } from '@mui/material';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
interface AnalysisData {
    battery: number
    coverageClass: number
    dateCreated: Date | string
    details: string
    energyLevel: number
    eventCode: number
    id: number
    loggerSerial: number
    porbor: number
    powerSavingConnsPerc: number | null
    recordCode: number
    remainingBattPerc: number | null
    remainingBattYears: number | null
    rssi: number
    siteName: string
    userFatal: number
    watchdogResets: number
    cellId: number | null
    actType: number | null
    band: number | null
    iccId: string
}

const DeviceAnalysis: React.FC = ({ serial }: { serial: number }) => {




    const [start, setStart] = useState<Date | null>(moment().subtract(7, 'days').toDate())
    const [end, setEnd] = useState<Date | null>(moment().toDate())
    const [gridData, setGridData] = useState<AnalysisData[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)
        CallGetAPI(CreateUrl(`/api/aquaguard/LoggerEvents?serial=${serial}&startDate=${moment(start).format("yyyy-MM-DD HH:mm:ss")}&endDate=${moment(end).format("yyyy-MM-DD HH:mm:ss") }`), {})
            .then(data => {
                if (data && data.length > 0) {
                    const filteredData = data.filter((d: AnalysisData) => d.eventCode === 42)
                    filteredData.forEach((d: AnalysisData) => {
                        if (d.battery) {
                            d.battery = d.battery / 1000
                        }

                        ///cellid
                        const cellIdIdx = d.details.indexOf('CellId')
                        const tacIdx = d.details.indexOf('TAC')

                        d.cellId = parseInt(d.details.slice(cellIdIdx + 8, tacIdx - 1))


                        ///actType
                        const actIdx = d.details.indexOf('AcT')
                        d.actType = parseInt(d.details.slice(actIdx + 10, cellIdIdx - 1))


                        ///band
                        const bandIdx = d.details.indexOf('Band')
                        const iccidIdx = d.details.indexOf('ICCID')
                        d.band = parseInt(d.details.slice(bandIdx + 6, iccidIdx - 5))


                        ///iccid 
                        const tempIdx = d.details.indexOf('Temp')
                        d.iccId = d.details.slice(iccidIdx + 7, tempIdx - 1)
                    })
                    setGridData(filteredData)
                    setLoading(false)
                } else {
                    setGridData([])
                    setLoading(false)
                }
            })
            .catch(err => {
                console.error(err)
                setLoading(false)
            })
    }, [start, end, serial])


    const renderDate = (data: ColumnCellTemplateData):React.ReactNode => {
        return moment(data.data.dateCreated).format('DD MMM YYYY HH:mm:ss')
    }

    const startDateChanged = (e):void => {
        setStart(moment(e.value).set({ hours: 0, minutes: 0, second: 0 }).toDate())
    }

    const endDateChanged = (e) => {
        setEnd(moment(e.value).set({hours: 23, minutes: 59, second: 59}).toDate())
    }


    const handleExport = () => {
        let worksheet: ExcelJS.Worksheet | null = null;
        const workbook = new ExcelJS.Workbook();
        worksheet = workbook.addWorksheet("All Channels", {
            views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }]
        });
        const headers = [
            { header: 'Created', key: 'dateCreated' },
            { header: 'Battery Voltage', key: 'battery' },
            { header: 'RSSI', key: 'rssi' },
            { header: 'Coverage Class', key: 'coverageClass' },
            { header: 'Energy Level', key: 'energyLevel' },
            { header: 'Porbor', key: 'porbor' },
            { header: 'User Fatal', key: 'userFatal' },
            { header: 'Watch Dog Resets', key: 'watchdogResets' },
            { header: 'Cell Id', key: 'cellId' },
            { header: 'ACT Type', key: 'actType' },
            { header: 'Band', key: 'band' },
            { header: 'ICC ID', key: 'iccId'}
        ]
        worksheet.columns = headers;
        const moddedData = gridData.map(d => {
            d.dateCreated = moment(d.dateCreated).format('DD MMM YYYY HH:mm:ss')
            return d
        })
        worksheet.addRows(moddedData);
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `DeviceAnalysisFor${serial}.xlsx`);
        });
    } 

    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading && <GridContainer>
                <GridItem xs={4} sm={4} md={4}>
                    Start date:&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={start} onValueChanged={startDateChanged} />
                </GridItem>
                <GridItem xs={4} sm={4} md={4} >
                    End date:&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={end} onValueChanged={endDateChanged} />
                </GridItem>
                <GridItem xs={4} sm={4} md={4} >
                    <div style={{marginTop: 25, display: 'flex', justifyContent: 'flex-end'} }>
                        <Button variant="contained" onClick={():void => handleExport()}>Export</Button>
                    </div>
                </GridItem>
                
                <div style={{marginTop: 30} }>
                <GridItem xs={12} sm={12} md={12}>
                    <DataGrid
                        dataSource={gridData}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                    >
                        <StateStoring enabled={true} type="localStorage" storageKey="deviceAnalysisGrid" />
                        {/*<Export enabled={true} />*/}
                        <FilterRow visible={true} />
                        <Column dataField='dateCreated' cellRender={(data): React.ReactNode => renderDate(data)} dataType='datetime' />
                        <Column dataField='battery' caption='Battery (V)' dataType='number' />
                        <Column dataField='rssi' dataType='number' />
                        <Column dataField="coverageClass" dataType='number' />
                        <Column dataField="energyLevel" dataType='number' />
                        <Column dataField='porbor' dataType='number' />
                        <Column dataField='userFatal' dataType='number' />
                        <Column dataField='watchdogResets' dataType='number' />
                        <Column dataField='cellId' dataType='number' />
                        <Column dataField='actType' dataType='number' />
                        <Column dataField='band' dataType='number' />
                        <Column dataField='iccId' dataType='string' />
                    </DataGrid>
                    </GridItem>
                </div>
            </GridContainer>}
        </div>
    )
}
export default DeviceAnalysis